/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HappeningCell_happening$ref = any;
type HappeningEdit_happening$ref = any;
export type UpdateHeroOfferInput = {|
  actionText?: ?string,
  callToAction?: ?string,
  clientMutationId?: ?string,
  description?: ?string,
  details?: ?string,
  endDate?: ?any,
  id: string,
  startDate?: ?any,
  storeId?: ?string,
  title?: ?string,
  url?: ?string,
|};
export type updateHappeningMutationVariables = {|
  input: UpdateHeroOfferInput
|};
export type updateHappeningMutationResponse = {|
  +updateHeroOffer: ?{|
    +heroOffer: ?{|
      +id: string,
      +$fragmentRefs: HappeningEdit_happening$ref & HappeningCell_happening$ref,
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateHappeningMutation = {|
  variables: updateHappeningMutationVariables,
  response: updateHappeningMutationResponse,
|};
*/


/*
mutation updateHappeningMutation(
  $input: UpdateHeroOfferInput!
) {
  updateHeroOffer(input: $input) {
    heroOffer {
      id
      ...HappeningEdit_happening
      ...HappeningCell_happening
    }
    errors {
      key
      messages
    }
  }
}

fragment HappeningCell_happening on HeroOffer {
  id
  title
  url
  imageUrl
  startDate
  endDate
}

fragment HappeningEdit_happening on HeroOffer {
  id
  title
  url
  imageUrl
  startDate
  endDate
  description
  details
  callToAction
  store {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateHeroOfferInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateHappeningMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHeroOfferPayload",
        "kind": "LinkedField",
        "name": "updateHeroOffer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HeroOffer",
            "kind": "LinkedField",
            "name": "heroOffer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HappeningEdit_happening"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HappeningCell_happening"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateHappeningMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHeroOfferPayload",
        "kind": "LinkedField",
        "name": "updateHeroOffer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HeroOffer",
            "kind": "LinkedField",
            "name": "heroOffer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "details",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "callToAction",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateHappeningMutation",
    "operationKind": "mutation",
    "text": "mutation updateHappeningMutation(\n  $input: UpdateHeroOfferInput!\n) {\n  updateHeroOffer(input: $input) {\n    heroOffer {\n      id\n      ...HappeningEdit_happening\n      ...HappeningCell_happening\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment HappeningCell_happening on HeroOffer {\n  id\n  title\n  url\n  imageUrl\n  startDate\n  endDate\n}\n\nfragment HappeningEdit_happening on HeroOffer {\n  id\n  title\n  url\n  imageUrl\n  startDate\n  endDate\n  description\n  details\n  callToAction\n  store {\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8eccc53458eb5f7e8a235493d2d60a5a';

module.exports = node;
